import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Table,
  Badge,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { Tabs, Tab } from "react-bootstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import Spinners from "components/Shared/Spinners"
import {
  addLoyaltyPoints,
  deleteCustomer,
  getCustomerDetails,
  getCustomerLoyaltyPoints,
  getPaymentHistory,
  getWalletHistory,
  revokeLoyaltyPoints,
  updateCustomerStatus,
} from "store/actions/customersAction"
import { useLocation, useNavigate } from "react-router"
import MiniCards from "components/Shared/mini-card"
import { getAllOrders } from "store/actions/orderAction"
import TableShimmer from "components/Shared/TableShimmer"
import Paginations from "components/Common/Paginations"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import { showAlert } from "store/reducers/alertReducer"
import formatDateTime from "components/Shared/formatDateTime"
import { ErrorMessage, Field, Form, Formik } from "formik"
import {
  addLoyaltyPointSchema,
  resolveMaxAdminLoyaltyPoints,
  revokeLoyaltyPointsSchema,
} from "components/Common/validation"
import { DatePicker } from "rsuite"
import { useTranslation } from "react-i18next"
import { disablePastDates } from "components/Common/constants"
import TextError from "components/Shared/TextError"
import Switch from "components/Shared/Switch"
import { getGlobalSettingByType } from "store/actions/globalSettingAction"

const initialValues = {
  points: null,
  remarks: "",
}

const addLoyaltyPointsValues = {
  remarks: "",
  points: "",
  expiresAt: "",
}

const CustomersView = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Customer Details | Sign Burger")

  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const [activeTab, setActiveTab] = useState("DEVICE_INFO")
  const pageNumber = parseInt(searchParams.get("page")) || 1

  const {
    loading,
    loyaltyLoading,
    error,
    isLoading,
    isUpdating,
    message,
    actionType,
    customerDetails,
    customerLoyaltyPoints,
    totalCount: loyaltyTotalCount,
    totalPages: loyaltyTotalPages,
    currentPage: loyaltyCurrentPage,
    paymentHistory,
    paymentHistoryLoading,
    paymentCurrentPage,
    paymentTotalPages,
    paymentTotalCount,
    walletHistory,
    walletHistoryLoading,
    walletTotalPages,
    walletCurrentPage,
    walletTotalCount,
  } = useSelector(state => state.Customers)

  const {
    loading: orderLoading,
    isLoading: orderIsLoading,
    isUpdating: orderIsUpdating,
    itemsPerPage,
    totalCount,
    totalPages,
    currentPage,
    orders,
  } = useSelector(state => state.Orders)

  const { userRole, accountType } = useSelector(state => state.Login)
  const { loyaltyInfo } = useSelector(state => state.GlobalSettings)
  const maxAdminLoyaltyPointsPerAdd = resolveMaxAdminLoyaltyPoints(
    loyaltyInfo?.loyaltyInfo?.maxAdminLoyaltyPointsPerAdd
  )

  const [customersPermissions, setCustomersPermissions] = useState({
    list: null,
    edit: null,
  })

  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [modalType, setModalType] = useState(null)
  const [customerSubPermissions, setCustomerSubPermissions] = useState({})
  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_1",
      accountType
    )

    // get sub permissions array
    const subPermissionsView = getSubPermissions(
      userRole,
      7,
      "customersPermission_1",
      accountType
    )

    // set sub permissions array data state
    setCustomerSubPermissions(subPermissionsView)

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_2",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setCustomersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  useEffect(() => {
    fetchCustomerDetails()
    fetchOrdersList()
    fetchCustomerLoyaltyPoints()
    dispatch(getGlobalSettingByType({ type: "loyaltyInfo" }))
  }, [])

  const fetchCustomerDetails = () => {
    const payload = {
      id,
    }
    dispatch(getCustomerDetails(payload))
  }

  const fetchCustomerLoyaltyPoints = tab => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: tab === "LOYALTY" ? 1 : pageNumber,
      orderBy: 2,
      keyword: "",
      userId: id,
    }
    dispatch(getCustomerLoyaltyPoints(payload))
    navigate(
      `/customers/customer-details?id=${id}&page=${
        tab === "LOYALTY" ? 1 : pageNumber
      }`
    )
  }

  const fetchOrdersList = tab => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: tab === "ORDERS" ? 1 : pageNumber,
      orderBy: 2,
      keyword: "",
      userId: id,
      status: 0,
    }
    dispatch(getAllOrders(payload))
    navigate(
      `/customers/customer-details?id=${id}&page=${
        tab === "ORDERS" ? 1 : pageNumber
      }`
    )
  }

  const fetchPaymentHistory = tab => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: tab === "PAYMENT_HISTORY" ? 1 : pageNumber,
      orderBy: 2,
      keyword: "",
      userId: id,
      dateRange: {},
      branchId: [],
    }
    dispatch(getPaymentHistory(payload))
    navigate(
      `/customers/customer-details?id=${id}&page=${
        tab === "PAYMENT_HISTORY" ? 1 : pageNumber
      }`
    )
  }

  const fetchWalletHistory = tab => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: tab === "WALLET_HISTORY" ? 1 : pageNumber,
      orderBy: 2,
      keyword: "",
      userId: id,
      dateRange: {},
      transactionType: 0, //1 credit, 2 debit, 0 all
    }
    dispatch(getWalletHistory(payload))
    navigate(
      `/customers/customer-details?id=${id}&page=${
        tab === "WALLET_HISTORY" ? 1 : pageNumber
      }`
    )
  }

  const handleTabChange = tab => {
    setActiveTab(tab)
    if (tab === "ORDERS") {
      navigate(`/customers/customer-details?id=${id}&page=1`)
      fetchOrdersList(tab)
    } else if (tab === "LOYALTY") {
      fetchCustomerLoyaltyPoints(tab)
    } else if (tab === "PAYMENT_HISTORY") {
      fetchPaymentHistory(tab)
    } else if (tab === "WALLET_HISTORY") {
      fetchWalletHistory(tab)
    } else if (tab === "RATINGS") {
    } else if (tab === "DEVICE_INFO") {
    }
  }

  const [miniCards, setMiniCards] = useState([])

  useEffect(() => {
    if (customerDetails) {
      const { ordersCount, totalPoints, totalAmount, totalWalletBalance } =
        customerDetails
      setMiniCards([
        {
          id: 1,
          title: t("Total Orders"),
          iconClass: "mdi mdi-cart-outline",
          text: ordersCount,
        },
        {
          id: 2,
          title: t("Total Loyalty Points"),
          iconClass: "mdi mdi-gift-outline",
          text: totalPoints > 0 ? totalPoints?.toFixed(2) : 0,
        },
        {
          id: 3,
          title: t("Total Amount Spent"),
          iconClass: "mdi mdi-wallet-outline",
          text: `${totalAmount?.toFixed(2)} SAR`,
        },
        {
          id: 4,
          title: t("Total Wallet Balance"),
          iconClass: "bx bx-wallet",
          text: `${totalWalletBalance?.toFixed(2) || 0} SAR`,
        },
      ])
    }
  }, [customerDetails, language])

  const statusMap = {
    0: { text: t("Pending"), color: "orange" },
    1: { text: t("Sent To Branch"), color: "blue" },
    2: { text: t("Start Preparing"), color: "green" },
    3: { text: t("Prepared"), color: "#ef0774" },
    4: { text: t("Collected"), color: "green" },
    5: { text: t("Cancelled"), color: "red" },
  }

  const formatPromiseDateTime = dateTimeString => {
    if (!dateTimeString) return "-"
    const date = new Date(dateTimeString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    let hours = date.getHours()
    const meridiem = hours >= 12 ? "PM" : "AM"
    hours = hours % 12 || 12 // Convert 0 to 12 for 12-hour clock
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const seconds = String(date.getSeconds()).padStart(2, "0")

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${meridiem}`
  }

  const onPageChange = page => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: 1,
      keyword: "",
      userId: id,
      status: 0,
    }
    dispatch(getAllOrders(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers/customer-details?id=${id}&page=${page}`)
        }
      })
      .catch(error => {})
  }

  const onLoyaltyPageChange = page => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: 1,
      keyword: "",
      userId: id,
    }
    dispatch(getCustomerLoyaltyPoints(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers/customer-details?id=${id}&page=${page}`)
        }
      })
      .catch(error => {})
  }

  const onPaymentHistoryPageChange = page => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: 2,
      keyword: "",
      userId: id,
      dateRange: {},
      branchId: [],
    }

    dispatch(getPaymentHistory(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers/customer-details?id=${id}&page=${page}`)
        }
      })
      .catch(error => {})
  }

  const onWalletHistoryPageChange = page => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: 2,
      keyword: "",
      userId: id,
      dateRange: {},
      transactionType: 0, //1 credit, 2 debit, 0 all
    }

    dispatch(getWalletHistory(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers/customer-details?id=${id}&page=${page}`)
        }
      })
      .catch(error => {})
  }

  const handleRevokeLoyaltyPoints = (values, resetForm) => {
    const { points, remarks } = values
    const payload = {
      remarks,
      points,
      customerId: id,
    }

    dispatch(revokeLoyaltyPoints(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          const currentLoyaltyPoints = Number(
            miniCards?.find(item => item.id === 2)?.text
          )
          const updatedLoyaltyPoints = currentLoyaltyPoints - points
          setMiniCards(prevCards =>
            prevCards?.map(card =>
              card.id === 2
                ? { ...card, text: updatedLoyaltyPoints.toFixed(2) }
                : card
            )
          )
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowModal(false)
          setModalType(null)
          resetForm()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleAddLoyaltyPoints = (values, { resetForm }) => {
    const { remarks, points, expiresAt } = values

    const payload = {
      remarks,
      points,
      expiresAt,
      customers: [id],
    }

    dispatch(addLoyaltyPoints(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          const currentLoyaltyPoints = Number(
            miniCards?.find(item => item.id === 2)?.text
          )
          const updatedLoyaltyPoints = currentLoyaltyPoints + points
          setMiniCards(prevCards =>
            prevCards?.map(card =>
              card.id === 2
                ? { ...card, text: updatedLoyaltyPoints.toFixed(2) }
                : card
            )
          )
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowModal(false)
          setModalType(null)
          resetForm()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleEnableCustomer = (id, status) => {
    const payload = {
      id,
      status: status === 1 ? "0" : "1",
    }
    dispatch(updateCustomerStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  if (loading) return <Spinners />

  return (
    <div className="page-content  customers_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl="7">
            <Card className="full_height_card">
              <CardBody>
                <CardTitle className="mb-4 d-flex align-items-center justify-content-between">
                  <div>
                    <i
                      className="bx bx-arrow-back me-1 fs-5 cursor-pointer"
                      onClick={() => navigate("/customers")}
                    ></i>{" "}
                    {t("Customer Information")}
                  </div>
                </CardTitle>

                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {Object.values(customerDetails).length === 0 ? (
                    <p className="text-center">
                      {t("No customer details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{customerDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              {customersPermissions.edit &&
                                customerDetails.status !== 2 && (
                                  <Switch
                                    onClickHandler={e => {
                                      e.stopPropagation()
                                      handleEnableCustomer(
                                        id,
                                        customerDetails.status
                                      )
                                    }}
                                    isChecked={customerDetails.status === 1}
                                    disabled={isUpdating}
                                  />
                                )}

                              <div style={{ marginTop: 2 }}>
                                {customerDetails.status === 1 ? (
                                  <Badge className="bg-success">
                                    {t("Active")}
                                  </Badge>
                                ) : customerDetails.status === 0 ? (
                                  <Badge className="bg-danger">
                                    {t("Deactive")}
                                  </Badge>
                                ) : customerDetails.status === 2 ? (
                                  <Badge className="bg-danger">
                                    {t("Deleted")}
                                  </Badge>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("First Name")}</th>
                          <td>{customerDetails.firstName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Last Name")}</th>
                          <td>{customerDetails.lastName || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Email")}</th>
                          <td>
                            {customerDetails.email || "-"}
                            {customerDetails.isEmailVerified && (
                              <i className="bx bxs-badge-check text-success mx-1"></i>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Gender")}</th>
                          <td>{customerDetails.gender || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("DOB")}</th>
                          <td>{customerDetails.dob || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Social Id")}</th>
                          <td>{customerDetails.socialId || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Referral Code")}</th>
                          <td>{customerDetails.referralCode || "-"}</td>
                        </tr>

                        <tr>
                          <th scope="row">{t("Phone Number")}</th>
                          <td>
                            {customerDetails.phoneCode}
                            {customerDetails.phoneNumber || "-"}
                            {customerDetails.isPhoneNoVerified && (
                              <i className="bx bxs-badge-check text-success mx-1"></i>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">{t("Login Type")}</th>
                          <td>
                            {customerDetails.loginType === "GOOGLE" ? (
                              <li className="social-list-item bg-danger text-white border-danger">
                                <i className="mdi mdi-google" />
                              </li>
                            ) : null}
                            {customerDetails.loginType === "APPLE" ? (
                              <li className="social-list-item bg-danger text-white border-danger">
                                <i className="mdi mdi-apple" />
                              </li>
                            ) : null}
                            {customerDetails.loginType ===
                            "PHONE_NUMBER_AND_PASSWORD" ? (
                              <li className="social-list-item bg-success text-white border-success">
                                <i className="mdi mdi-cellphone" />
                              </li>
                            ) : null}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Last Logged In")}</th>
                          <td>
                            {formatDateTime(customerDetails.lastLoggedIn)}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("created At")}</th>
                          <td>{formatDateTime(customerDetails.createdAt)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl="5">
            {customersPermissions.list &&
              customerSubPermissions?.view_loyalty_points?.isEnabled && (
                <Card>
                  <CardBody>
                    <div className="d-flex align-items-center justify-content-between">
                      {customerDetails.totalPoints > 0 && (
                        <Button
                          color="warning"
                          onClick={() => {
                            setShowModal(true)
                            setModalType("REVOKE_LOYALTY_POINTS")
                          }}
                        >
                          {t("Revoke Loyalty Points")}
                        </Button>
                      )}
                      <Button
                        color="primary"
                        onClick={() => {
                          setShowModal(true)
                          setModalType("ADD_LOYALTY_POINTS")
                        }}
                      >
                        {t("Add Loyalty Points")}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              )}
            {(miniCards || [])?.map((card, key) => (
              <MiniCards
                title={card.title}
                text={card.text}
                iconClass={card.iconClass}
                key={"_card_" + key}
                cardCol={12}
              />
            ))}
          </Col>
        </Row>
        <Row>
          <Col>
            <Tabs
              activeKey={activeTab}
              onSelect={handleTabChange}
              className="mb-2"
            >
              {(accountType === "superadmin" ||
                (customersPermissions.list &&
                  customerSubPermissions?.view_device_information
                    ?.isEnabled)) && (
                <Tab eventKey="DEVICE_INFO" title={t("Device Information")}>
                  <Card style={{ maxHeight: 600 }}>
                    <CardBody>
                      {customerDetails && customerDetails.deviceInfos ? (
                        <Table className="table mb-0">
                          <tbody>
                            <tr>
                              <th scope="row">{t("S. No.")}</th>
                              <th>{t("Device Id")}</th>
                              <th>{t("Language")}</th>
                              <th>{t("App Version")}</th>
                              <th>{t("OS Version")}</th>
                              <th>{t("Platform")}</th>
                            </tr>

                            {customerDetails?.deviceInfos.map(
                              (
                                {
                                  _id,
                                  deviceId,
                                  language,
                                  appVersion,
                                  osVersion,
                                  platform,
                                },
                                index
                              ) => (
                                <tr key={_id}>
                                  <td>{index + 1}</td>
                                  <td>{deviceId}</td>
                                  <td>{language}</td>
                                  <td>{appVersion}</td>
                                  <td>{osVersion}</td>
                                  <td>{platform}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <p className="my-3 text-center">
                          {t("No device info found")}
                        </p>
                      )}
                    </CardBody>
                  </Card>
                </Tab>
              )}

              {(accountType === "superadmin" ||
                (customersPermissions.list &&
                  customerSubPermissions?.view_orders?.isEnabled)) && (
                <Tab eventKey="ORDERS" title={t("Orders")}>
                  <Card>
                    <CardBody className="overflow-auto">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: 600 }}
                      >
                        {orderLoading ? (
                          <TableShimmer row={5} col={5} />
                        ) : orders.length === 0 ? (
                          <p className="text-center my-2">
                            {t("No orders found")}
                          </p>
                        ) : (
                          <Table className="table mb-0">
                            <thead className="fixed_thead full_th">
                              <tr>
                                <th>{t("S. No.")}</th>
                                <th>{t("Name")}</th>
                                <th>{t("Order No")}</th>
                                <th>{t("Branch Name")}</th>
                                <th>{t("Amount Paid")}</th>
                                <th>{t("Payment Method")}</th>
                                <th>{t("Order Status")}</th>
                                {/* <th>{t("Payment Status")}</th> */}
                                <th>{t("Order Date")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {orders?.map((item, index) => (
                                <tr
                                  key={item._id}
                                  onClick={() => {
                                    navigate(
                                      `/orders/order-details?id=${item._id}`
                                    )
                                  }}
                                  className="cursor-pointer"
                                >
                                  <td>{(pageNumber - 1) * 10 + index + 1}</td>
                                  <td>{item?.name || "-"}</td>
                                  <td>{item?.invoiceNo || "-"}</td>

                                  <td>
                                    {language === "sa"
                                      ? item?.branchNameAr
                                      : item?.branchName || "-"}
                                  </td>

                                  <td>
                                    {item.paidAmount} (
                                    {t(item?.splitPayments?.currency)})
                                  </td>
                                  <td>
                                    <i
                                      className={`${
                                        item.paymentMethod === "CARD"
                                          ? "fab fa-cc-mastercard me-1"
                                          : "" || item.paymentMethod === "APPLE"
                                          ? "fab bx bxl-apple me-1"
                                          : ""
                                      }`}
                                    ></i>
                                    {t(item.paymentMethod)}
                                  </td>
                                  <td>
                                    <span
                                      style={{
                                        color:
                                          statusMap[item.orderStatus].color,
                                      }}
                                    >
                                      {statusMap[item.orderStatus].text}
                                    </span>
                                  </td>
                                  {/* <td>
                                    {" "}
                                    {item.paymentStatus === 1 && (
                                      <Badge className="bg-success">
                                        {t("Paid")}
                                      </Badge>
                                    )}
                                    {item.paymentStatus === 2 && (
                                      <Badge className="bg-success">
                                        {"Refunded"}
                                      </Badge>
                                    )}
                                  </td> */}

                                  <td>
                                    {formatPromiseDateTime(
                                      item.promiseDateTime
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </div>
                      {!orderLoading && orders.length > 0 && (
                        <div className="mt-3">
                          <Paginations
                            data={orders}
                            itemsPerPage={itemsPerPage}
                            onPageChange={onPageChange}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalCount={totalCount}
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Tab>
              )}
              {(accountType === "superadmin" ||
                (customersPermissions.list &&
                  customerSubPermissions?.view_loyalty_points?.isEnabled)) && (
                <Tab eventKey="LOYALTY" title={t("Loyalty Points")}>
                  <Card>
                    <CardBody className="overflow-auto">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: 600 }}
                      >
                        {loyaltyLoading ? (
                          <TableShimmer row={5} col={5} />
                        ) : customerLoyaltyPoints.length === 0 ? (
                          <p className="text-center my-2">
                            {t("No loyalty points found")}
                          </p>
                        ) : (
                          <Table className="table mb-0 capitalize_td">
                            <thead className="fixed_thead">
                              <tr>
                                <th>{t("S. No.")}</th>
                                <th>{t("Name")}</th>
                                <th>{t("Phone Number")}</th>
                                <th>{t("Order No")}</th>
                                <th>{t("Points")}</th>
                                <th>{t("Type")}</th>
                                <th>{t("Source")}</th>
                                <th>{t("Expires At")}</th>
                                <th>{t("Created At")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {customerLoyaltyPoints?.map((item, index) => (
                                <tr key={item._id}>
                                  <td>{(pageNumber - 1) * 10 + index + 1}</td>
                                  <td>{item?.userData?.name}</td>
                                  <td>{item?.userData?.phoneNumber || "-"}</td>
                                  <td>{item?.orderNo || "-"}</td>
                                  <td>{item?.points || "-"}</td>
                                  <td
                                    className={`
                                ${
                                  item?.type === "collect" ? "text-success" : ""
                                }
                                ${item?.type === "redeem" ? "text-danger" : ""}
                                ${item?.type === "cancel" ? "text-warning" : ""}
                                `}
                                  >
                                    {t(item?.type)}
                                  </td>
                                  <td>{item?.source || "-"}</td>
                                  <td>{formatDateTime(item?.expiresAt)}</td>
                                  <td>{formatDateTime(item?.createdAt)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </div>
                      {!loading && customerLoyaltyPoints.length > 0 && (
                        <div className="mt-3">
                          <Paginations
                            data={customerLoyaltyPoints}
                            itemsPerPage={itemsPerPage}
                            onPageChange={onLoyaltyPageChange}
                            currentPage={loyaltyCurrentPage}
                            totalPages={loyaltyTotalPages}
                            totalCount={loyaltyTotalCount}
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Tab>
              )}
              {(accountType === "superadmin" ||
                (customersPermissions.list &&
                  customerSubPermissions?.view_payment_history?.isEnabled)) && (
                <Tab eventKey="PAYMENT_HISTORY" title={t("Payment History")}>
                  <Card>
                    <CardBody className="overflow-auto">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: 600 }}
                      >
                        {paymentHistoryLoading ? (
                          <TableShimmer row={5} col={5} />
                        ) : paymentHistory.length === 0 ? (
                          <p className="text-center my-2">
                            {t("No payment history found")}
                          </p>
                        ) : (
                          <Table className="table mb-0 capitalize_td">
                            <thead className="fixed_thead">
                              <tr>
                                <th>{t("S. No.")}</th>
                                <th>{t("Invoice No")}</th>
                                <th>{t("Branch Name")}</th>
                                {/* <th>{t("Order No")}</th> */}
                                <th>{t("Amount")}</th>
                                <th>{t("Payment Method")}</th>
                                <th>{t("Gateway")}</th>
                                <th>{t("Gateway Status")}</th>
                                <th>{t("Created")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paymentHistory?.map((item, index) => (
                                <tr key={item._id}>
                                  <td>{(pageNumber - 1) * 10 + index + 1}</td>
                                  <td>{item?.invoiceNo}</td>
                                  <td>{item?.branchName || "-"}</td>
                                  {/* <td>{item?.orderId || "-"}</td> */}
                                  <td>{item?.amount + " SAR" ?? "-"}</td>
                                  <td>{item?.paymentMethod || "-"}</td>
                                  <td>{item?.gateway || "-"}</td>
                                  <td>{item?.gatewayStatus || "-"}</td>
                                  <td>{formatDateTime(item?.createdAt)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </div>
                      {!loading && paymentHistory.length > 0 && (
                        <div className="mt-3">
                          <Paginations
                            data={paymentHistory}
                            itemsPerPage={itemsPerPage}
                            onPageChange={onPaymentHistoryPageChange}
                            currentPage={paymentCurrentPage}
                            totalPages={paymentTotalPages}
                            totalCount={paymentTotalCount}
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Tab>
              )}
              {/*  */}
              {(accountType === "superadmin" ||
                (customersPermissions.list &&
                  customerSubPermissions?.view_wallet_history?.isEnabled)) && (
                <Tab eventKey="WALLET_HISTORY" title={t("Wallet History")}>
                  <Card>
                    <CardBody className="overflow-auto">
                      <div
                        className="table-responsive"
                        style={{ maxHeight: 600 }}
                      >
                        {walletHistoryLoading ? (
                          <TableShimmer row={5} col={5} />
                        ) : walletHistory?.length === 0 ? (
                          <p className="text-center my-2">
                            {t("No wallet history found")}
                          </p>
                        ) : (
                          <Table className="table mb-0 capitalize_td">
                            <thead className="fixed_thead">
                              <tr>
                                <th>{t("Transaction No")}</th>
                                <th>{t("Type")}</th>
                                <th>{t("Amount")}</th>
                                <th>{t("From Name")}</th>
                                <th>{t("Points")}</th>
                                <th>{t("Source")}</th>
                                <th>{t("Created At")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {walletHistory?.map((item, index) => (
                                <tr key={item._id}>
                                  <td>{item?.txnNo}</td>
                                  <td>{item?.type || "-"}</td>
                                  <td>{item?.amount ?? "-"}</td>
                                  <td>{item?.fromName || "-"}</td>
                                  <td>{item?.points ?? "-"}</td>
                                  <td>{item?.source || "-"}</td>
                                  <td>{formatDateTime(item?.createdAt)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}
                      </div>
                      {!loading && walletHistory?.length > 0 && (
                        <div className="mt-3">
                          <Paginations
                            data={walletHistory}
                            itemsPerPage={itemsPerPage}
                            onPageChange={onWalletHistoryPageChange}
                            currentPage={walletCurrentPage}
                            totalPages={walletTotalPages}
                            totalCount={walletTotalCount}
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Tab>
              )}
            </Tabs>
          </Col>
        </Row>
      </div>

      <Modal
        isOpen={showModal}
        toggle={() => {
          setShowModal(false)
          setModalType(null)
        }}
      >
        <ModalHeader
          toggle={() => {
            setShowModal(false)
            setModalType(null)
          }}
        >
          {modalType === "ADD_LOYALTY_POINTS" && t("Add Loyalty Points")}
          {modalType === "REVOKE_LOYALTY_POINTS" && t("Revoke Loyalty Points")}
        </ModalHeader>
        <ModalBody>
          {modalType === "REVOKE_LOYALTY_POINTS" && (
            <Formik
              initialValues={initialValues}
              validationSchema={revokeLoyaltyPointsSchema}
              onSubmit={handleRevokeLoyaltyPoints}
            >
              {({ values, errors, touched, setFieldValue }) => (
                <Form>
                  <div className="row">
                    <div className="col-lg-12 ">
                      <div className="form_field">
                        <label htmlFor="points">
                          <span className="text-danger">*</span> {t("Points")}
                        </label>
                        <Field
                          type="number"
                          id="points"
                          name="points"
                          placeholder={t("Points")}
                          className={`form-control ${
                            touched.points && errors.points ? "is-invalid" : ""
                          }`}
                        />
                        <TextError name="points" />
                      </div>
                    </div>

                    <div className="col-lg-12 mt-2">
                      <div className="form_field">
                        <label htmlFor="remarks">
                          <span className="text-danger">*</span> {t("Remark")}
                        </label>
                        <Field
                          as="textarea"
                          id="remarks"
                          name="remarks"
                          placeholder={t("Remark")}
                          className={`form-control ${
                            touched.remarks && errors.remarks
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="remarks" />
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                      <Button
                        color="secondary"
                        type="button"
                        onClick={() => {
                          setShowModal(false)
                          setModalType(null)
                        }}
                      >
                        {t("Cancel")}
                      </Button>
                      <Button
                        color="success"
                        className="ms-2"
                        disabled={isLoading}
                      >
                        {t("Revoke")}
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          )}

          {modalType === "ADD_LOYALTY_POINTS" && (
            <Formik
              initialValues={addLoyaltyPointsValues}
              validationSchema={addLoyaltyPointSchema(
                null,
                maxAdminLoyaltyPointsPerAdd
              )}
              onSubmit={handleAddLoyaltyPoints}
            >
              {({ values, setFieldValue, errors, touched }) => (
                <Form>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form_field">
                        <label htmlFor="points">
                          <span className="text-danger">*</span> {t("Points")}
                        </label>
                        <Field
                          type="number"
                          id="points"
                          name="points"
                          placeholder={t("Points")}
                          className={`form-control ${
                            touched.points && errors.points ? "is-invalid" : ""
                          }`}
                        />
                        <small className="text-muted">
                          {t("Max allowed: {{max}} points", {
                            max: maxAdminLoyaltyPointsPerAdd,
                          })}
                        </small>
                        <TextError name="points" />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form_field full_rs_picker">
                        <label htmlFor="expiresAt">{t("Expires At")}</label>
                        <DatePicker
                          showTime={{ format: "HH:mm" }} // Show time picker
                          format="yyyy-MM-dd HH:mm" // Custom format for displaying date and time
                          onChange={value => {
                            setFieldValue("expiresAt", value)
                          }}
                          value={values.expiresAt}
                          placeholder=" 2024-07-16 14:30"
                          disabledDate={disablePastDates}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form_field">
                        <label htmlFor="name">
                          <span className="text-danger">*</span> {t("Remark")}
                        </label>
                        <Field
                          as="textarea"
                          id="remarks"
                          name="remarks"
                          placeholder={t("Remark")}
                          className={`form-control ${
                            touched.remarks && errors.remarks
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="remarks" />
                      </div>
                    </div>

                    <div className="mt-2"></div>
                    <div className="col-12 d-flex justify-content-end ">
                      <Button
                        type="button"
                        className="mx-2"
                        color="secondary"
                        onClick={() => {
                          setShowModal(false)
                          setModalType(null)
                        }}
                      >
                        {t("Cancel")}
                      </Button>
                      <Button
                        type="submit"
                        color="success"
                        disabled={isLoading}
                        className="w_fit_content"
                      >
                        {t("Add")}
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default CustomersView
